var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g({staticClass:"snt-chip",style:({ backgroundColor: `var(--v-${_vm.color}-light-base) !important` }),attrs:{"color":_vm.color,"small":_vm.small,"close":_vm.close,"height":_vm.height,"label":_vm.label,"outlined":""}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }